<div class="position-relative w-100 overall-value-container" [style.height.px]="height"></div>
<div
    class="position-relative value-container"
    [style.height.px]="height"
    [style.top.px]="-height"
    [ngClass]="{ 'value-container-max-warning': warningBackgroundWhenMax && value >= overallValue }"
    [caWidth]="overallValue === 0 ? 0 : ((value / overallValue) * 100 <= 100 ? (value / overallValue) * 100 : 100) + '%'"
></div>
